import {
    getImageQuality,
    getCssClasses
} from '@corratech/pylot-rich-content/src/PageBuilder/utils'

/**
 * Determine the button type based on class
 *
 * @param {HTMLElement} node - DOM element to check for button type.
 * @returns {string} - Button type ('secondary', 'link', or 'primary').
 */
const getButtonType = (node) => {
    if (
        node.getAttribute('data-w-button-type') ===
        'pagebuilder-button-secondary'
    ) {
        return 'secondary'
    }

    if (node.getAttribute('data-w-button-type') === 'pagebuilder-button-link') {
        return 'link'
    }

    if (
        node.getAttribute('data-w-button-type') ===
        'pagebuilder-button-catalog-primary'
    ) {
        return 'catalog'
    }

    return 'primary'
}

/**
 * Configures settings and returns an object with parsed attributes.
 *
 * @param {HTMLElement} node - The DOM node containing configuration data.
 * @param {Object} props - Additional properties if required.
 * @returns {Object} - Configured settings object.
 */
const configAggregator = (node) => {
    const getAttr = (attr, defaultValue = null) =>
        node.getAttribute(attr) || defaultValue
    const showButton = getAttr('data-w-show-button')
    const buttonText = getAttr('data-w-button-text')
    const buttonLink = getAttr('data-w-button-link')
    const showOverlay = getAttr('data-w-show-overlay')
    const minHeight = getAttr('data-w-min-height')
    const backgroundColor = getAttr('data-w-background-color')
    const images = getAttr('data-background-images')
    const heading = getAttr('data-w-top-heading')
    const subHeading = getAttr('data-w-sub-heading')
    const kicker = getAttr('data-w-kicker')
    const textColor = getAttr('data-w-text-color')
    const videoSource = getAttr('data-video-src')
    const mobileVideoSource = getAttr('data-mobile-video-src')
    const heroBannerTheme = getAttr('data-theme')

    const imageObj = {
        desktop_image: null,
        mobile_image: null,
        tablet_image: null,
        backgroundSize: getAttr('data-w-background-size'),
        backgroundPosition: getAttr('data-w-background-position'),
        backgroundRepeat: getAttr('data-w-background-repeat') !== 'no-repeat'
    }

    if (images) {
        try {
            const imagesStructure = JSON.parse(images.replace(/\\"/g, '"'))
            imageObj.desktop_image = imagesStructure.desktop_image || null
            imageObj.tablet_image = imagesStructure.tablet_image || null
            imageObj.mobile_image = imagesStructure.mobile_image || null
        } catch (error) {
            console.error('Failed to parse image data:', error)
        }
    }

    return {
        minHeight: minHeight || null,
        heading: heading,
        subHeading: subHeading,
        kicker: kicker,
        textColor: textColor,
        backgroundColor,
        ...imageObj,
        link: buttonLink || null,
        showButton,
        buttonText: buttonText && showButton !== 'never' ? buttonText : null,
        buttonType: showButton !== 'never' ? getButtonType(node) : null,
        showOverlay,
        heroBannerTheme: heroBannerTheme,
        overlayColor:
            node.getAttribute('data-w-overlay-color') && showOverlay !== 'never'
                ? node.getAttribute('data-w-overlay-color')
                : null,
        backgroundType: node.getAttribute('data-background-type'),
        videoSrc: videoSource,
        videoMobileSource: mobileVideoSource,
        videoLoop: node.getAttribute('data-w-video-loop') === 'true',
        imageQuality: getImageQuality([]),
        ...getCssClasses(node)
    }
}

export default configAggregator
